import React, { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: "What are the requirements to rent a car?",
    answer:
      "To rent a car, you must be at least 21 years old, have a valid driver’s license, and provide a credit or debit card for payment and security deposit.",
  },
  {
    question: "Do I need insurance to rent a car?",
    answer: "Yes, renters must have insurance. You can use your own policy, or purchase coverage from us at the time of rental.",
  },
  {
    question: "Is there a mileage limit on rented cars?",
    answer: "Most of our rentals come with a mileage limit, but unlimited mileage options are available for an extra fee.",
  },
  {
    question: "Can I rent a car for someone else?",
    answer:
      "Yes, but the person renting must meet our age and license requirements and be listed as the primary driver on the agreement.",
  },
  {
    question: "What should I do in case of an accident or breakdown?",
    answer: "Contact our 24/7 roadside assistance team immediately and follow the instructions given. If necessary, call emergency services.",
  },
  {
    question: "How do I return the rental car?",
    answer: "Return the car to the designated drop-off location on time, with the agreed fuel level, and in clean condition to avoid extra charges.",
  },
];

const FAQItem: React.FC<{ faq: FAQItem; isOpen: boolean; onToggle: () => void }> = ({
  faq,
  isOpen,
  onToggle,
}) => {
  return (
    <div className={`p-6 rounded-xl transition-all bg-green-100 shadow-md flex flex-col h-full` }>
      <button
        onClick={onToggle}
        className="flex justify-between items-center w-full text-left text-lg font-semibold"
      >
        {faq.question}
        <span>{isOpen ? <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.707 1.70697L12.293 0.292969L6.99997 5.58597L1.70697 0.292969L0.292969 1.70697L5.58597 6.99997L0.292969 12.293L1.70697 13.707L6.99997 8.41397L12.293 13.707L13.707 12.293L8.41397 6.99997L13.707 1.70697Z" fill="#666666"/>
</svg>
 : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="#666666"/>
</svg>
}</span>
      </button>
      <div className={`overflow-hidden transition-max-height duration-300 ease-in-out `}>
        {isOpen && <p className="mt-2 text-gray-600 text-left">{faq.answer}</p>}
      </div>
    </div>
  );
};

const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="text-center py-10 px-6">
      <p className="text-4xl font-bold mb-6">FAQs</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6  mx-auto items-start">
        {faqs.map((faq, index) => (
          <FAQItem
            key={index}
            faq={faq}
            isOpen={openIndex === index}
            onToggle={() => handleToggle(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQSection;